"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=categoryOptionGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/categoryOptionGroupSet.js
// module id = 489
// module chunks = 0